import OrchestratorAPI from './common.js';
import {
  type CreateValues,
  type CredentialGroup,
  type FindAllOptions,
  type UpdateValues,
} from '../models/orchestrator/credentialGroup.js';
import { type PaginatedQueryOptions, type PaginationResponse } from '../models/pagination/index.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/credential-groups';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findOneById(id: string): Promise<CredentialGroup> {
    const url = this.constructPath(`/${id}`);
    return (await this.common.getJSON(url)).credentialGroup;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<CredentialGroup>> {
    const url = this.constructPath('/', options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<CredentialGroup> {
    const url = this.constructPath('/');
    return (await this.common.postJSON(url, values)).credentialGroup;
  }

  async update(id: string, values: UpdateValues): Promise<CredentialGroup> {
    const url = this.constructPath(`/${id}`);
    return (await this.common.patchJSON(url, values)).credentialGroup;
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    await this.common.deleteJSON(url);
  }
}
